import { api } from "./api";

/**Sales Report */
export const overallSalesReportApi = (params) => {
  return api.post(`/report/over-all-sales`, JSON.stringify(params));
};

export const purchaseOrderReportApi = (params) => {
  return api.post(`/report/purchase-order`, JSON.stringify(params));
};

export const dailySalesReportApi = (params) => {
  return api.post(`/report/daily-sales`, JSON.stringify(params));
};

export const productWiseSalesReportApi = (params) => {
  return api.post(`report/product-wise-sales`, JSON.stringify(params));
};

export const productPurchaseReturnReportWorkerReportApi = (params) => {
  return api.post(`/report/product-purchase-return`, JSON.stringify(params));
};

export const GetAddedFavApi = (params) => {
  return api.get(`/report/get-added-fav`, JSON.stringify(params));
}

export const SetAddedFavApi = (params) => {
  return api.post(`report/set-added-fav`, JSON.stringify(params));
}

export const B2bSalesSummaryReportWorkerReportApi = (params) => {
  return api.post(`/report/b2b-sales-summary`, JSON.stringify(params));
};

export const StorePurchaseReportWorkerReportApi = (params) => {
  return api.post(`/report/product-summary`, JSON.stringify(params));
};

export const ReOrderReportWorkerReportApi = (params) => {
  return api.post(`/report/reOrder`, JSON.stringify(params));
};

export const SavedReportsReportWorkertApi = (params) => {
  return api.post(`/report/get-saved-reports`, JSON.stringify(params));
};

export const AddTagsApi = (params) => {
  return api.post(`/report/modify-tag`, JSON.stringify(params));
};

export const GetTagsApi = (params) => {
  return api.post(`/report/get-tag`, JSON.stringify(params));
};

export const SavedReportsReportDataWorkertApi = (params) => {
  return api.post(`/report/get-saved-report-data`, JSON.stringify(params));
};

export const branchWiseSalesReportApi = (params) => {
  return api.post(`/report/branch-wise-sales`, JSON.stringify(params));
};

export const doctorWiseSalesReportApi = (params) => {
  return api.post(`/report/doctor-wise-sales`, JSON.stringify(params));
};

export const partyWiseSalesReportApi = (params) => {
  return api.post(`/report/party-wise-sales`, JSON.stringify(params));
};

export const paymentModeWiseSalesReportApi = (params) => {
  return api.post(`/report/payment-mode-wise-sales`, JSON.stringify(params));
};

/**Financial & Revenue */
export const partyWiseProfitReportApi = (params) => {
  return api.post(`/report/party-wise-profit`, JSON.stringify(params));
};

export const discountAnalysisReportApi = (params) => {
  return api.post(`/report/discount-analysis`, JSON.stringify(params));
};

/**Sales Return Reports */
export const salesReturnReportApi = (params) => {
  return api.post(`/report/sales-return`, JSON.stringify(params));
};

/**Customer Reports */
export const customerPurchaseFreqReportApi = (params) => {
  return api.post(
    `/report/customer-purchase-frequency`,
    JSON.stringify(params)
  );
};

export const customerPurchaseBehaviorReportApi = (params) => {
  return api.post(`/report/customer-purchase-behavior`, JSON.stringify(params));
};

export const bounceReportApi = (params) => {
  return api.post(`/report/bounce`, JSON.stringify(params));
};

export const addBounceReportApi = (params) => {
  return api.post(`/billing/addCustomerBounce`, JSON.stringify(params));
};

export const inventorySalesReportApi = (params) => {
  const { pageNumber, pageSize, ...rest } = params;
  return api.post(
    `/report/stock-sales-report?pageNumber=${pageNumber ?? 1}&pageSize=${pageSize ?? 50}`,
    JSON.stringify(rest)
  );
};

export const inventoryReportApi = (params) => {
  return api.post(`/report/inventory`, JSON.stringify(params));
};

export const scheduledHDrugRegReportApi = (params) => {
  return api.post(`/report/scheduled-hdrug-reg`, JSON.stringify(params));
};

export const expiryLossReportApi = (params) => {
  return api.post(`/report/expiry-loss`, JSON.stringify(params));
};

export const customerPayableApi = (params) => {
  return api.post(`report/customerPayable`, JSON.stringify(params));
};

export const productInfoApi = (params) => {
  return api.post(`/report/product-info`, JSON.stringify(params));
};

export const profitReportApi = (params) => {
  return api.post(`report/profitWise`, JSON.stringify(params));
};

export const VendorMasterReportApi = (params) => {
  return api.post(`report/vendorMaster`, JSON.stringify(params));
};

export const StockLedgerReportApi = (params) => {
  return api.post(`report/stockLedgerBatch`, JSON.stringify(params));
};

export const vendorPaybleReportApi = (params) => {
  return api.post(`report/vendorPayable`, JSON.stringify(params));
};

export const dayWiseReportApi = (params) => {
  return api.post(`/report/dayWise`, JSON.stringify(params));
};

export const slowAndFastMovingProductsReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};

// gst report

export const gstR1ReportApi = (params) => {
  return api.post(`/report/gst/gstr-1`, JSON.stringify(params));
};
export const gstr2AReportApi = (params) => {
  return api.post(`/report/gst/gstr-2`, JSON.stringify(params));
};
export const gstr3bReportApi = (params) => {
  return api.post(`/report/gst/gstr-3B`, JSON.stringify(params));
};
export const gstRHsnCodeSummaryReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};

export const gstr9ReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
export const gstr9cReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
export const gstItcMismatchReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
export const gstEWayBillReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
export const gstPaymentSummaryReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
export const gstItcAgingReportApi = (params) => {
  return api.post(`/report/slow-fast-moving-products`, JSON.stringify(params));
};
